import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Col, Pagination, Row } from "antd";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import AppVSkeleton from "src/components/skeleton/AppVSkeleton";
import { ProductHistory } from "src/models/product.model";
import ProductService from "src/services/API/Product";
import { useSearchParams } from "react-router-dom";
import useHideBottomBar from "src/hooks/useHideBottomBar";
import { Desktop, Mobile } from "src/layouts/break-point";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/store/configureStore";
import { getNoticeTransactionDashboard } from "src/store/MyPage";
import { usePrompt } from "src/hooks/useBlocker";
import AppPullToRefresh from "src/layouts/pull-refresh/AppPullToRefresh";
import PurchaseHistoryItem from "./PurchaseHistoryItem";
import { PURCHASE_HISTORY_TYPE } from "../../model";
import Tab from "./Tab";

const PurchaseHistoryList: FC = ({ ...props }) => {
  // const routerTx = useRef();

  // const blocker = useCallback((tx: any) => {
  //   routerTx.current = tx;
  //   // eslint-disable-next-line @typescript-eslint/no-use-before-define
  //   if (searchParam.get("tab") === "0") {
  //     // eslint-disable-next-line @typescript-eslint/no-use-before-define
  //     getListHistory(0, true);
  //   } else {
  //     (routerTx.current as any).retry();
  //   }
  // }, []);

  // usePrompt(blocker, true);

  useHideBottomBar(false);
  const dispatch = useDispatch<AppDispatch>();

  const [searchParam, setSearchParam] = useSearchParams();
  const [saleList, setSaleList] = useState<ProductHistory[]>([]);
  const { t: translate } = useTranslation();
  const page = useRef(0);
  const totalCount = useRef(0);
  const numberOfPage = 20;
  const numberOfPagePC = 5;
  const config = [
    { label: translate("my.page.tab.1"), value: 0 },
    { label: translate("my.page.tab.2"), value: 1 },
  ];

  const [loading, setLoading] = useState(false);

  const appScroll = useRef<HTMLElement | undefined>(undefined);

  const [currentValue, setCurrentValue] = useState<PURCHASE_HISTORY_TYPE>(
    PURCHASE_HISTORY_TYPE.TRADING
  );

  function getListHistory(value: PURCHASE_HISTORY_TYPE, isLoading: boolean) {
    page.current = isLoading ? 0 : page.current;
    appScroll.current?.scrollTo({ top: 0, behavior: "smooth" });
    setLoading(isLoading);
    ProductService.getPurchaseHistory(
      window.innerWidth > 768
        ? ((((Number(searchParam.get("currentPage")) || 1) - 1) *
            numberOfPagePC) as number)
        : page.current * numberOfPage,
      window.innerWidth > 768 ? numberOfPagePC : numberOfPage,
      value
    )
      .then((res) => {
        setLoading(false);
        totalCount.current = res.data.result.totalCount;

        setSaleList(
          isLoading
            ? res.data.result.items
            : saleList.concat(res.data.result.items)
        );
        page.current += 1;
        if (value === PURCHASE_HISTORY_TYPE.TRADING) {
          dispatch(getNoticeTransactionDashboard());
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const handleTabChange = (value: PURCHASE_HISTORY_TYPE) => {
    if (!loading) {
      setCurrentValue(value);
      searchParam.set("tab", `${value}`);
      if (window.innerWidth > 768) {
        searchParam.set("currentPage", "1");
      }
      setSearchParam(searchParam);
    }
  };

  useEffect(() => {
    if (
      searchParam.get("tab") &&
      Number(searchParam.get("tab")) !== currentValue
    ) {
      setCurrentValue(Number(searchParam.get("tab")) as PURCHASE_HISTORY_TYPE);
    }
    getListHistory(
      searchParam.get("tab") ? Number(searchParam.get("tab")) : currentValue,
      true
    );
  }, [searchParam]);

  useEffect(() => {
    const scroll = document.getElementById("appLayout") || undefined;
    appScroll.current = scroll;
  }, []);

  return (
    <AppPullToRefresh
      onRefresh={() => {
        getListHistory(currentValue, true);
      }}
    >
      <div className="ui-my-page-purchase-history">
        <Row gutter={[32, 32]} justify="center">
          <Col xs={24}>
            <Tab
              config={config}
              currentValue={currentValue}
              onChange={handleTabChange}
            />
          </Col>
        </Row>

        <div className="ui-my-page-purchase-history__items" id="scrollableDiv">
          {loading ? (
            <>
              <AppVSkeleton />
              <AppVSkeleton />
              <AppVSkeleton />
            </>
          ) : (
            <>
              <Mobile>
                <InfiniteScroll
                  dataLength={saleList.length}
                  next={() => {
                    getListHistory(currentValue, false);
                  }}
                  hasMore={
                    saleList.length > 0 && saleList.length < totalCount.current
                  }
                  loader={undefined}
                  scrollableTarget="scrollableDiv"
                >
                  {saleList &&
                    saleList.length > 0 &&
                    saleList.map((item, index) => (
                      <PurchaseHistoryItem
                        key={item.id}
                        item={item}
                        onReload={() => {
                          getListHistory(currentValue, true);
                        }}
                      />
                    ))}
                </InfiniteScroll>
              </Mobile>
              <Desktop>
                {saleList &&
                  saleList.length > 0 &&
                  saleList.map((item, index) => (
                    <PurchaseHistoryItem
                      key={item.id}
                      item={item}
                      onReload={() => {
                        getListHistory(currentValue, true);
                      }}
                    />
                  ))}

                {saleList && saleList.length > 0 && (
                  <div className="ui-my-page-purchase-history__pagination">
                    <Pagination
                      current={Number(searchParam.get("currentPage")) || 1}
                      pageSize={numberOfPagePC}
                      total={totalCount.current}
                      defaultCurrent={1}
                      showSizeChanger={false}
                      onChange={(value) => {
                        searchParam.set("currentPage", `${value}`);
                        setSearchParam(searchParam);
                      }}
                    />
                  </div>
                )}
              </Desktop>
            </>
          )}
        </div>
      </div>
    </AppPullToRefresh>
  );
};

export default PurchaseHistoryList;

PurchaseHistoryList.defaultProps = {};
